import { createAppI18n } from '@it-tools/shell'
import '@it-tools/shell/tokens.css'
import '@it-tools/shell/doc.css'
import '@it-tools/shell/controls.css'
import { createApp } from 'vue'
import App from './App.vue'
import en from './locales/en.json'
import es from './locales/es.json'
import ptBR from './locales/pt-BR.json'

const i18n = createAppI18n({ en, 'pt-BR': ptBR, es })

createApp(App).use(i18n).mount('#app')
